<template>
  <el-checkbox-group v-model="warehouseIds">
    <el-checkbox
      v-for="row in list"
      :key="row.warehouseId"
      :label="row.warehouseId">{{ row.warehouseName }}[{{ row.warehouseNo }}]</el-checkbox>
  </el-checkbox-group>
</template>
<script>
// import _ from 'lodash'
export default {
  name: 'WarehouseCheckbox',
  components: {},
  props: {
    value: {
      required: true
    },
    option: {
      type: Object,
      default() {
        return {
          pageNum: 1,
          pageSize: 1000,
          productType: 1,
          useType: 1
        }
      }
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    warehouseIds: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$store.dispatch('outstock/getwarehouses', {
        payload: this.option,
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
